import React, { FC, memo, useMemo, useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import ErrorMessage from '@minecraft.error-message';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { FilterData } from '../../../shared/types';
import { generateSelectOptionsBasedOnField } from '../../../shared/utils';
import { SEARCH_ROSTER_LISTS } from '../FilterBasicCollectionGraphQL';

type Props = FilterData;

const RosterLists: FC<Props> = ({ name, label }) => {
  const [getRosterLists, { data, error, loading }] = useLazyQuery(SEARCH_ROSTER_LISTS);

  const handleListsFetch = useCallback((): void => {
    if (!data) {
      getRosterLists();
    }
  }, [data]);

  const rosterOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(data?.getOrganizationProfileLists?.objects, 'name');
  }, [data?.getOrganizationProfileLists?.objects]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    <DropdownWithChildren
      withFormik
      withSearch
      withSelectAll
      isMultipleSelect
      isLoading={loading}
      name={name}
      toggleLabel={label}
      options={rosterOptions}
      onOptionsFetch={handleListsFetch}
    />
  );
};

export default memo(RosterLists);
